import { jsx as _jsx } from "react/jsx-runtime";
/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*	QWorkspaceVertical	- content display and resizing
*	When given panel contents and a page, displays content in resizable panels.*/
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './TS_Workspace.scss';
import { ModuleFE_Workspace } from '../modules/ModuleFE_Workspace.js';
export class TS_Workspace extends ComponentSync {
    toRender = false;
    deriveStateFromProps(nextProps, state) {
        state.key = nextProps.workspaceKey;
        return state;
    }
    _deriveStateFromProps(nextProps) {
        const state = super._deriveStateFromProps(nextProps);
        this.toRender = true;
        return state;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.toRender) {
            this.toRender = false;
            return true;
        }
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    onConfigChanged = async () => {
        const config = ModuleFE_Workspace.getWorkspaceConfigByKey(this.state.key);
        await ModuleFE_Workspace.setWorkspaceByKey(this.state.key, config);
    };
    render() {
        const config = ModuleFE_Workspace.getWorkspaceConfigByKey(this.state.key);
        const PanelRenderer = this.props.renderers[config.key];
        if (!PanelRenderer)
            return `COULD NOT GET THE WORKSPACE RENDERER FOR KEY ${config.key}`;
        const className = _className('ts-workspace', this.props.className);
        return _jsx("div", { className: className, id: this.props.id, children: _jsx(PanelRenderer, { config: config.data, renderers: this.props.renderers, instances: this.props.instances, onConfigChanged: this.onConfigChanged }) });
    }
}
//# sourceMappingURL=TS_Workspace.js.map